<template>
  <a href="/" data-turbo="false" class="flex items-center space-x-2 rtl:space-x-reverse">
    <img src="@/images/logo_128.png" class="h-8" alt="PicEditor" />
    <span>
      <span class="self-center text-2xl md:text-3xl font-bold whitespace-nowrap text-primary">PicEditor</span>
      <span class="text-xl md:text-2xl font-semibold text-gray-600">.io</span>
    </span>
  </a>
</template>
